import React from 'react';
import extendClassNameWithModifier from '../../../../lib/bemUtils/bem';
import { SVG, SVGIcon } from '../../../../components/atoms/SVG';

import { getFileIcon } from './DownloadFileIcon.utils';
import { Modifier } from '../../../../lib/bemUtils/Modifier';

export const DownloadFileIconModifier = {
  RELATIVE: 'relative',
  SMALL: 'small',
};

type DownloadFileIcon = {
  modifier?: Modifier<'relative' | 'small'>;
  fileExtension: string;
};

type FileIcon = {
  svgSprite: SVGIcon;
  modifier?: Modifier<'relative' | 'small'>;
  className?: string;
};

/**
 * Generic Icon Component for Files and Structure Icons.
 */
export function FileIcon({ modifier, svgSprite, className }: FileIcon) {
  return (
    <span className={extendClassNameWithModifier('download-file-icon', modifier)}>
      <SVG svgSpriteId={svgSprite} svgClass={className} />
    </span>
  );
}

/**
 * Icon representing a File by its extension.
 */
export function DownloadFileIcon({ modifier, fileExtension }: DownloadFileIcon) {
  const { iconFileName, className } = getFileIcon(fileExtension);
  return <FileIcon className={className} modifier={modifier} svgSprite={iconFileName} />;
}
